/* The Chat | Agents shell (chat makeover #2718) */
.shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* A segmented switch, styled as the ui-lib toggle buttons */
.switch {
  display: flex;
  margin: 0 var(--tuna-spacing-2) var(--tuna-spacing-1);
  border-radius: var(--tuna-shape-borderRadius);
}

.tab {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  border: 1px solid var(--tuna-palette-divider);
  background: none;
  color: var(--tuna-palette-text-secondary);
  cursor: pointer;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-button-fontSize);
  text-transform: none;
  padding: 4px 12px;
}

.tab:first-child {
  border-radius: var(--tuna-shape-borderRadius) 0 0 var(--tuna-shape-borderRadius);
}

.tab:last-child {
  border-left: none;
  border-radius: 0 var(--tuna-shape-borderRadius) var(--tuna-shape-borderRadius) 0;
}

.tab:hover {
  background: var(--tuna-palette-action-hover);
}

.tab:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
  z-index: 1;
}

.selected {
  color: var(--tuna-palette-primary-main);
  background: color-mix(in oklch, var(--tuna-palette-primary-main) 12%, transparent);
}

.visibility {
  margin: 0 var(--tuna-spacing-2) var(--tuna-spacing-1);
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}

.body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 44px targets on touch */
@media (pointer: coarse) {
  .tab {
    min-height: 44px;
  }
}
